<template>
  <PageShell class="page-shell-wrapper--blog-post" locale="id" hide-title>
    <BlogPostContent v-if="slug" :slug="slug" />
  </PageShell>
</template>

<script>
import PageShell from '@/components/layout/PageShell.vue';
import BlogPostContent from './BlogPostContent.vue';

export default {
  name: 'BlogPostPage',
  components: { PageShell, BlogPostContent },
  computed: {
    slug() {
      return this.$route.meta.slug || '';
    },
  },
};
</script>
